module.exports = function() {
  return new Worker(__webpack_public_path__ + "bc9c44906ab270af72a7.worker.js");
};